

































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {Action, State} from 'vuex-class'

import {AccountStatus as AccountStatusInterface} from '@/lib/kepler/interfaces'
import {ProfileState} from '@/store/modules/profile'
import {AppConfigState} from '@/store/modules/configuration'
import {EventBus} from '@/main'
import Utils from '@/utils'
import {PopupState} from '@/store'
import AccountFlow from '@/views/Flows/FlowAutoload.vue'
import {FlowInputsState} from '@/store/modules/flowInputs'

@Component({
  components: {
    Layout: Utils.loadComponent('proxy/Layout'),
    Img: Utils.loadComponent('proxy/Image'),
    Button: Utils.loadComponent('Button'),
    Icon: Utils.loadComponent('proxy/Icon'),
    CardButton: Utils.loadComponent('CardButton'),
  },
  name: 'AccountStatus',
})
export default class AccountStatus extends Vue {

  @State('profile') public profileState!: ProfileState
  @State('flowInputs') public flowInputs!: FlowInputsState
  @State('configuration') public configurationState!: AppConfigState
  @State((state) => state.profile.driver.main_driver) public isMainDriver!: boolean
  @State((state) => state.profile.status) public status!: AccountStatusInterface

  @Action('loadConfig') public loadConfig: any
  @Action('accountStatus') public accountStatus!: any
  @Action('setActionButtons') public setActionButtons!: any
  @Action('getFlows') public getFlows: any
  @Action('openDialog') public openDialog!: any
  @Action('openPopup') public openPopup!: any
  @Action('closePopup') public closePopup!: any

  protected statusLoaded: boolean = false
  protected isRefreshing: boolean = false

  @Watch('statusState', {deep: true})
  protected statusChanged() {
    if (this.completed) {
      this.close()
    }
  }

  @Watch('$route', {deep: true})
  protected onPageRefresh() {
    if (this.$route.path === '/') {
      this.loadStatus()
    }
  }

  protected created() {
    this.getFlows()
    this.loadStatus()
    EventBus.$on('login', this.loadStatus)
  }

  protected destroyed() {
    EventBus.$off('configurationReady')
    EventBus.$off('login', this.loadStatus)
  }

  protected close() {
    this.$emit('closeLoader', this.completed)
  }

  protected getPathAction(config: string) {
    // status[config] && detailedStatus(config) !== 'missing'
    if ((this as any).status[config] && this.detailedStatus(config) !== 'missing') {
      return
    }

    const checkMissingOrUndefined = (key: string, action: () => void) => {
      const s = this.detailedStatus(key)
      if (s === 'missing' || s === undefined) {
        action()
      }
    }

    const cases: { [key: string]: () => void } = {
      client: () => {
        checkMissingOrUndefined('client', () => {
          this.$router.push({name: 'manage profile'})
        })
      },
      driver: () => {
        checkMissingOrUndefined('driver', () => {
          this.$router.push({name: 'manage profile'})
        })
      },
      document: () => {
        checkMissingOrUndefined('document', () => {
          this.$router.push({name: 'add new document'})
        })
      },
      payment_method: () => {
        this.$router.push({name: 'add new card', hash: '#payment-methods'})
      },
      signed_tocs: () => {
        this.$router.push({name: 'terms'})
      },
      subscription: () => {
        if (this.isMainDriver) {
          this.$router.push({name: 'activities', hash: '#plans'})
        }
      },
    }
    cases[config]()
  }

  protected loadStatus() {
    this.isRefreshing = true
    this.accountStatus().then(() => {
      this.isRefreshing = false
      this.statusLoaded = true
    })
  }

  protected hasDetailedStatus(statusKey: string) {
    return statusKey === 'client' || statusKey === 'driver' || statusKey === 'document'
  }

  protected detailedStatus(statusKey: string) {
    if (this.hasDetailedStatus(statusKey)) {
      return this.status[statusKey + '_status'] as 'missing' | 'pending_validation' | 'valid' | undefined
    }
  }

  protected canShow(config: string) {
    const main = this.isMainDriver
    const onlyMain = ['client', 'subscription', 'client', 'payment_method']
    const onlySub = ['subscription_driver']
    const excluded = main ? onlySub : onlyMain

    return !excluded.includes(config)
  }

  protected openFlow(flowName: string) {
    const flow = this.flowInputs[flowName]
    if (flow) {
      this.openPopup(new PopupState(AccountFlow, {flowName}))
    }
  }

  get completed() {
    const statuses = Object.values(this.status)
    return statuses.every((v) => {
      return v === true || v === 'valid'
    })
  }

  get availableFlows() {
    return Object.keys(this.flowInputs)
  }
}
